/**
 * clientCsv.js — client-side CSV / download utilities.
 *
 * Zero-server dependency: takes an array of plain objects, generates a
 * proper RFC 4180 CSV in the browser, and triggers a download. Works
 * offline. Works forever — CSV format has been stable for 60 years.
 *
 * Usage:
 *   downloadCsv("rent-roll-2026.csv", [{unit:"101", rent:1800}, …]);
 */

function _esc(v) {
  if (v == null) return "";
  const s = typeof v === "string" ? v : (typeof v === "object" ? JSON.stringify(v) : String(v));
  // Quote if the value contains any special CSV chars.
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Build a UTF-8 CSV string from an array of plain objects.
 * Headers = union of all keys, sorted alphabetically for stability.
 */
export function toCsv(rows, fieldsOverride) {
  if (!Array.isArray(rows) || rows.length === 0) return "";
  const fields = fieldsOverride || [...new Set(rows.flatMap((r) => Object.keys(r || {})))].sort();
  const header = fields.map(_esc).join(",");
  const body = rows.map((r) => fields.map((f) => _esc(r[f])).join(",")).join("\n");
  // BOM so Excel opens as UTF-8 on Windows.
  return "\uFEFF" + header + "\n" + body + "\n";
}

/**
 * Trigger a browser download of the given CSV string as `filename`.
 * Uses `Blob` + object-URL, revokes the URL immediately after click.
 */
export function downloadCsv(filename, rows, fieldsOverride) {
  const csv = typeof rows === "string" ? rows : toCsv(rows, fieldsOverride);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}
